export default __webpack_public_path__ + "static/media/minus-disabled.9363ca05.svg";